const regExValidateEmail = /^[a-zA-Z0-9.!#$%&�*+/=?^_`{|}~-]+@\[?[a-zA-Z0-9-]+\]?/;

export function validateEmailList(userEmails: string): boolean {
    let isEmailValid = true;
    if (userEmails && userEmails !== '') {
        userEmails
            .split(',')
            .map(mail => mail?.trim())
            .filter(mail => mail && mail !== '')
            .forEach(mail => {
                isEmailValid = regExValidateEmail.test(mail);
            });
    }
    return isEmailValid;
}